import {api} from 'app/modules/Remote';
import type {ApiImageryCheckoutPreviewItem} from 'app/modules/Remote/api';

/**
 * Stripe's price for one card charge: its minimum-order top-up, service fee and tax. Only the fields
 * the charge depends on are part of the key.
 */
export function checkoutPreviewQuery(
  organizationId: string,
  items: ApiImageryCheckoutPreviewItem[]
) {
  const priced = items.map(({projectId, centsPerAcre, billableAcres}) => ({
    projectId,
    centsPerAcre,
    billableAcres,
  }));
  return {
    queryKey: ['checkoutPreview', organizationId, priced],
    queryFn: () => api.imagery.checkouts.preview(priced),
    staleTime: 5 * 60 * 1000,
    retry: false,
    refetchOnWindowFocus: false,
  };
}
